import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { programsSearch, programsSearchSuccess } from './program.actions';
import { ProgramService } from './program.service';
import { loadError } from '../error/error.action';
import { createActionError } from '../../models/action-error';
import { Program } from 'src/generated/graphql';

@Injectable()
export class ProgramEffects {
  constructor(private actions$: Actions, private programService: ProgramService) {}

  public programsSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(programsSearch),
      switchMap(({ searchTerm }) =>
        this.programService.programsSearch(searchTerm).pipe(
          map((response) =>
            programsSearchSuccess({
              programs: (response.data.programsSearch || []) as Program[]
            })
          ),
          catchError((error) => {
            return of(loadError(createActionError(error.message ?? 'Programs Search Failed.')));
          })
        )
      )
    )
  );
}
